import { AccountInfo, AuthenticationResult, PopupRequest } from "@azure/msal-browser";
import { IMsalProvider } from "./IMsalProvider";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./MsalConfig";
import { appContext } from "../AppContext";
import { SecurityProviderEnum } from "../Providers.LocalStorage/Models";

export class MsalProvider implements IMsalProvider
{
    public msalClient = new PublicClientApplication(msalConfig);

    public get clientId(): string
    {
        return appContext().localStorageProvider.getAadConfig().clientId;
    }

    public set clientId(value: string)
    {
        const config = appContext().localStorageProvider.getAadConfig();
        config.clientId = value;
        appContext().localStorageProvider.setAadConfig(config);
    }

    public get tenantDomain(): string
    {
        return appContext().localStorageProvider.getAadConfig().tenantDomain;
    }

    public set tenantDomain(value: string)
    {
        const config = appContext().localStorageProvider.getAadConfig();
        config.tenantDomain = value;
        appContext().localStorageProvider.setAadConfig(config);
    }

    public get securityProviderType(): SecurityProviderEnum | undefined
    {
        return appContext().localStorageProvider.getAadConfig().securityProviderType;
    }

    public set securityProviderType(value: SecurityProviderEnum | undefined)
    {
        const config = appContext().localStorageProvider.getAadConfig();
        config.securityProviderType = value;
        appContext().localStorageProvider.setAadConfig(config);
    }

    public initialise(): Promise<void>
    {
        if (!this.clientId || !this.tenantDomain)
        {
            throw new Error('Cannot initialise MSAL without a client ID and tenant domain.');
        }

        msalConfig.auth.clientId = this.clientId;
        msalConfig.auth.authority = this.getAuthority();
        msalConfig.auth.knownAuthorities = (this.securityProviderType === 'B2C' ? [this.getExternalIdHost()] : []);
        this.msalClient = new PublicClientApplication(msalConfig);
        return this.msalClient.initialize();
    }

    /**
     * Workforce (AAD) tenants authenticate against login.microsoftonline.com, whereas Entra External ID
     * (B2C) tenants authenticate against their own <tenant>.ciamlogin.com host.
     */
    private getAuthority(): string
    {
        if (this.securityProviderType === 'B2C')
        {
            return `https://${this.getExternalIdHost()}/${this.tenantDomain}/`;
        }
        return `https://login.microsoftonline.com/${this.tenantDomain}/`;
    }

    private getExternalIdHost(): string
    {
        const tenantName = this.tenantDomain.split('.')[0];
        return `${tenantName}.ciamlogin.com`;
    }

    public getAccount(): (AccountInfo | null)
    {
        return this.msalClient.getAllAccounts()[0];
    }

    public loginPopup(request: PopupRequest): Promise<AuthenticationResult>
    {
        return this.msalClient.loginPopup(request);
    }

    public async acquireTokenSilent(): Promise<AuthenticationResult>
    {
        const account = this.msalClient.getAllAccounts()[0];

        const authResult = await this.msalClient.acquireTokenSilent({
            account: account,
            scopes: [`api://${this.clientId}/User.Read`],
        });
        return authResult;
    }
}
